module.exports = __webpack_public_path__ + "web/img/sign-30.09c1edb2.png";